// common
export const RESET_STATE = 'reset'

// --
export const SET_USER = 'setUser'
export const SET_PENDING = 'setPending'
